<template>
    <nav>
        <!-- Hamburger menu button on mobile -->
        <div class="block lg:hidden">
            <button type="button"
                class="text-xl fa fa-bars text-gray-600 px-3 py-3 -mt-2 -mr-1"
                @click="showMobile"
            ></button>
        </div>

        <transition name="fade">
            <div v-if="show_mobile"
                class="lg:hidden flex flex-col items-center justify-center fixed z-100 inset-0 w-full h-full bg-black bg-opacity-85"
            >
                <!-- Close button -->
                <button type="button"
                    class="absolute top-0 right-0 text-2xl fa fa-times-circle text-gray-600 px-4 py-4"
                    @click="hideMobile"
                ></button>

                <div class="mb-8">
                    <language :dark="true" />
                </div>

                <broker-nav-links
                    :current="current"
                    :routes="routes"
                    :user="user"
                />
            </div>
        </transition>

        <!-- Desktop menu -->
        <div class="hidden lg:flex items-center pt-1 pb-5">
            <div class="mr-4 pb-0.5">
                <language :dark="true" />
            </div>

            <broker-nav-links
                :current="current"
                :routes="routes"
                :user="user"
            />
        </div>
    </nav>
</template>

<script>
import BrokerNavLinks from './broker-nav-links.vue';
import Language from './language.vue';

export default {
    components: {
        BrokerNavLinks,
        Language,
    },

    props: {
        current: {},
        routes: {},
        user: {},
    },

    data() {
        return {
            show_mobile: false,
        }
    },

    methods: {
        showMobile() {
            this.show_mobile = true;
        },
        hideMobile() {
            this.show_mobile = false;
        },
    },

    watch: {
        show_mobile(val) {
            if (val) {
                document.body.style.position = 'fixed';
                document.body.style.top = `-${window.scrollY}px`;
            } else {
                const scrollY = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        },
    },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>

